import { VerificationFormData } from 'features/customerPanel/accountVerification/interface/verification';
import { FormikErrors, FormikTouched } from 'formik';
import { SetStateAction } from 'react';
import { TFunction } from 'react-i18next';
import FormRow from 'shared/components/form/formRow';
import FormSubTitle from 'shared/components/form/formSubTitle';
import InputRadioGroup from 'shared/components/form/inputRadioGroup';
import InputUpload from 'shared/components/form/inputUpload';
import { PASSPORT, PERSONAL_ID, STANDING_CARD_STAY } from 'shared/constants/common';
import { isFieldValueValid } from 'shared/util/utility';

interface AccountVerificationFormStep5Props {
	t: TFunction<'translation'>;
	values: VerificationFormData;
	errors: FormikErrors<{ [field: string]: any }>;
	touched: FormikTouched<{}>;
	handleBlur: (e: React.FocusEvent<any>) => void;
	setFieldError: (field: string, val: any) => void;
	setFieldTouched: (name: string, bool: boolean) => void;
	setFieldValue: (field: string, val: any) => void;
	setValues: (values: SetStateAction<VerificationFormData>, shouldValidate?: boolean) => void;
	fileUploadFront: any;
	fileUploadBack: any;
}

const AccountVerificationFormStep5 = ({
	t,
	values,
	setFieldValue,
	setFieldError,
	setFieldTouched,
	touched,
	errors,
	fileUploadBack,
	fileUploadFront,
	setValues,
}: AccountVerificationFormStep5Props) => {
	const radioButtons = [
		{ value: PERSONAL_ID, label: t('personalEvidence') },
		{ value: PASSPORT, label: t('passport') },
		{ value: STANDING_CARD_STAY, label: t('standingCardStay') },
	];

	const openUploader = (target: any) => {
		target.current.click();
	};

	return (
		<>
			<FormSubTitle title={t('verificationStep3SubTitle')} />
			<FormRow>
				<InputRadioGroup
					name="documentType"
					values={values}
					radioButtons={radioButtons}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setValues({ ...values, uploadFront: '', uploadBack: '', seriesNumber: '', expirationDate: '' });
						const val = (e.target as HTMLInputElement).value;
						setFieldValue('documentType', val);
						setFieldError('documentType', '');
					}}
					cyTestRef="document"
				/>
			</FormRow>
			<FormRow flex={false}>
				<InputUpload
					name="uploadFront"
					label={t('uploadFront')}
					ref={fileUploadFront}
					values={values}
					isFieldValueValid={isFieldValueValid}
					setFieldValue={setFieldValue}
					openUploader={openUploader}
					errors={errors}
					touched={touched}
					setFieldTouched={setFieldTouched}
					cyTestRef="upload-front"
					cyErrorRef="validation-error"
				/>
			</FormRow>
			{values.documentType !== 'passport' && (
				<FormRow flex={false}>
					<InputUpload
						name="uploadBack"
						label={t('uploadBack')}
						ref={fileUploadBack}
						values={values}
						isFieldValueValid={isFieldValueValid}
						setFieldValue={setFieldValue}
						openUploader={openUploader}
						errors={errors}
						touched={touched}
						setFieldTouched={setFieldTouched}
						cyTestRef="upload-back"
						cyErrorRef="validation-error"
					/>
				</FormRow>
			)}
		</>
	);
};

export default AccountVerificationFormStep5;
